const aboutPageSchema = ({
  url,
  title,
  description,
  image,
}) => ({
  "@context": "https://schema.org",
  "@type": "AboutPage",

  "@id": `${url}#webpage`,
  url,
  name: title,
  description,

  isPartOf: {
    "@id": "https://irisimpulse.com/#website",
  },

  about: {
    "@id": "https://irisimpulse.com/#organization",
  },

  mainEntity: {
    "@id": "https://irisimpulse.com/#organization",
  },

  ...(image && {
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: image,
    },
  }),

  inLanguage: "en",
});

export default aboutPageSchema;
